import { Routes } from '@angular/router';

import { PortfolioDisplayStore } from './features/portfolio/portfolio-display.store';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./features/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'rollock',
    loadChildren: () =>
      import('./features/rollock/rollock.routes').then((m) => m.rollockRoutes),
  },
  {
    path: 'predictions',
    loadChildren: () =>
      import('./features/predictions/predictions.routes').then(
        (m) => m.predictionsRoutes,
      ),
  },
  {
    path: 'portfolio',
    // Route-scoped display store — destructs + rebuilds on navigation,
    // forcing fresh fetch on re-entry. See docs/state-management.md §3b.
    providers: [PortfolioDisplayStore],
    loadComponent: () =>
      import('./features/portfolio/portfolio.page').then(
        (m) => m.PortfolioPage,
      ),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
